module.exports = __webpack_public_path__ + "img/icon-roulette.b84caa35.svg";